import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { addItemInArray, deleteItemFromArray, MediaItem } from '@mtgame/core';

@Injectable()
export class MediaSelectionService {
  private selectedSubject = new BehaviorSubject<MediaItem[]>([]);
  private enabledSubject = new BehaviorSubject<boolean>(false);

  get selected$() {
    return this.selectedSubject;
  }

  get enabled$() {
    return this.enabledSubject;
  }

  select(item: MediaItem): void {
    this.selectedSubject.next(addItemInArray(this.selectedSubject.value, item));
  }

  unselect(item: MediaItem): void {
    this.selectedSubject.next(deleteItemFromArray(this.selectedSubject.value, item));
  }

  unselectAll() {
    this.selectedSubject.next([]);
  }

  enable(): void {
    this.enabledSubject.next(true);
  }

  disable(): void {
    this.enabledSubject.next(false);
    this.unselectAll();
  }
}
